import { api } from "@api/api";
import { MagazineTemplate } from "@modules/magazineTemplates/types";
import { MagazineTemplateFormValues } from "@modules/magazineTemplates/validations";

export async function createMagazineTemplateService(data: MagazineTemplateFormValues): Promise<MagazineTemplate> {
  const { file, cover, ...payload } = data;

  const { data: magazineTemplate } = await api.post<MagazineTemplate>(
    "v2/magazine/magazine_template_admin/",
    payload
  );

  if (file && file instanceof File || cover && cover instanceof File) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("cover", cover);

    await api.patch(`v2/magazine/magazine_template_admin/${magazineTemplate.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return magazineTemplate;
}
